import { render } from "./ThirdPartyList.vue?vue&type=template&id=4e48204c&ts=true"
import script from "./ThirdPartyList.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyList.vue?vue&type=script&lang=ts"

import "./ThirdPartyList.vue?vue&type=style&index=0&id=4e48204c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__